module.exports = __webpack_public_path__ + "media/images/company-logos/company-logos-mobile-19fee3152a16f343c4e2359d1101743d.jpg";